import React from 'react';
import { styled } from '@compiled/react';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { ff } from '@atlassian/jira-feature-flagging';
import { useShowStatuses } from '@atlassian/jira-software-view-settings/src/controllers/index.tsx';
import { useContainerSize } from '../../../../hooks/use-is-compact-view';
import { getLabelWidthMultiplier, LabelType } from '../../utils/responsive-labels';
import StatusField from '../index';

type Props = {
	isUserAtLeastMember: boolean;
	shouldRenderRichCard: boolean;
	cardKey: string;
	cardId: number;
};

export const StatusFieldWrapper = ({
	isUserAtLeastMember,
	shouldRenderRichCard,
	cardKey,
	cardId,
}: Props) => {
	const showStatuses = useShowStatuses();
	const { size: backlogContainerSize } = useContainerSize();

	if (showStatuses) {
		return (
			<StatusContainer
				data-testid="software-backlog.card-list.card.card-contents.status-field.status-field-wrapper.status-container"
				widthMultiplier={getLabelWidthMultiplier(LabelType.STATUS, backlogContainerSize)}
			>
				<StatusField
					isUserAtLeastMember={isUserAtLeastMember}
					shouldRenderRichCard={shouldRenderRichCard}
					issueKey={cardKey}
					issueId={String(cardId)}
					widthMultiplier={getLabelWidthMultiplier(LabelType.STATUS, backlogContainerSize)}
				/>
			</StatusContainer>
		);
	}
	return null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StatusContainer = styled.div<{ widthMultiplier: number }>({
	display: 'grid',
	pointerEvents: 'none',
	// ensure styling remains consistent between rich and non-rich components
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: () =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		ff('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? undefined : '24px',
	overflow: 'inherit',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	gridTemplateColumns: ({ widthMultiplier }) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		`repeat(auto-fit,${gridSize * widthMultiplier}px)`,
});
